import { apiSlice } from "../../../app/api/apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getFilteredMilestoneCount: builder.mutation({
			// query: (credentials) => ({
			// 	url: `/api/v1/admin/loan/pipeline_modified/milestone/?email=${credentials?.brokerEmail}&loan_channel=${credentials?.loan_channel}&organization=${credentials?.orgName}`,
			// 	method: "GET",
			// }),

			query: (credentials) => {
				const email = encodeURIComponent(credentials?.brokerEmail ?? "");
				const loanChannel = encodeURIComponent(credentials?.loan_channel ?? "");
				const organization = encodeURIComponent(credentials?.orgName ?? "");
				return {
					url: `/api/v1/admin/loan/pipeline_modified/milestone/?email=${email}&loan_channel=${loanChannel}&organization=${organization}`,
					method: "GET",
				};
			},
		}),
	}),
});

export const { useGetFilteredMilestoneCountMutation } = usersApiSlice;
